import { useTranslation } from 'react-i18next';
import ReactHtmlParser from 'react-html-parser';

const CabeceraTipoBarco = ({ lang, eltipo }) => {
    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    var titulofoto = "";
    var textofoto = "";
    var textofoto2 = "";

    if (eltipo.id == 41) {
        titulofoto = t("GOLETAS: ​Tradición y confort en alta mar");
        textofoto = t("Las goletas son barcos con alma. Con su silueta clásica y su cubierta de madera, ofrecen una experiencia única donde se combina el encanto de la navegación tradicional con todas las comodidades modernas. Son espaciosas, acogedoras y perfectas para quienes buscan disfrutar del mar en un ambiente relajado y exclusivo.");
        textofoto2 = t("Embárcate en una experiencia única y descubre el placer de navegar con estilo.");
    }
    else if (eltipo.id == 42) {
        titulofoto = t("YATES: Exclusividad y lujo en el mar");
        textofoto = t("Los yates son la máxima expresión de confort y distinción en la navegación. Con líneas modernas, interiores sofisticados y tecnología de vanguardia, ofrecen una experiencia incomparable donde cada detalle está pensado para tu bienestar. Amplios, elegantes y versátiles, son ideales para quienes buscan disfrutar del mar con total privacidad.");
        textofoto2 = t("Vive la libertad del mar desde otra perspectiva y descubre la auténtica esencia del lujo a bordo.");
    }
    else if (eltipo.id == 40) {
        titulofoto = t("CATAMARANES: Estabilidad, espacio y confort");
        textofoto = t("Los catamaranes ofrecen una forma única de navegar, combinando amplitud y comodidad con una estabilidadexcepcional. Sus dos cascos garantizan una travesía relajada, mientras que sus amplias cubiertas e interiores luminosos crean el ambiente perfecto para compartir. Modernos, versátiles y pensados para grupos o familias, son la opción ideal para disfrutar del mar con libertad, confort y estilo.");
        textofoto2 = t("Vive la experiencia de moverte con espacio y descubre el placer de navegar sin límites.");
    }
    else if (eltipo.id == 19) {
        titulofoto = t("CRUCEROS BOUTIQUE: Exclusividad y encanto en cada travesía").replaceAll(": ", ":<br/>");
        textofoto = t("Los cruceros boutique ofrecen una experiencia íntima y personalizada, muy diferente a la de los grandes buques. Con un número reducido de pasajeros, cada detalle está cuidado para garantizar confort, atención cercana y una atmósfera selecta. Elegantes, acogedores y llenos de carácter, son perfectos para quienes desean descubrir destinos únicos.");
        textofoto2 = t("Embárcate en un crucero donde la exclusividad se une al encanto de navegar.");
    }
    else {
        titulofoto = t("");
        textofoto = t("");
        textofoto2 = t("");
    }

    return (
        <>
            <section className="u-align-center u-clearfix u-container-align-center u-image u-shading u-valign-top-lg u-valign-top-md u-valign-top-sm u-valign-top-xs u-section-1" id="block-15" data-image-width="1766" data-image-height="1032" style={{ backgroundImage: `linear-gradient(0deg, rgba(26, 26, 26, 0.15), rgba(26, 26, 26, 0.15)), url(/images/web/onboard2/${eltipo.nombre.replace(" ", "-")}.jpg)` }}>
                {(eltipo.id == 42 || eltipo.id == 19) ?
                    <div className="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-sm u-sheet-1">
                        <h2 className="u-align-center u-custom-font u-font-oswald u-text u-text-body-alt-color u-text-1">{ReactHtmlParser(titulofoto)}<br />
                        </h2>
                        <p className="u-align-center u-large-text u-text u-text-body-alt-color u-text-variant u-text-2" data-animation-name="customAnimationIn" data-animation-duration="1000" data-animation-delay="0" style={{ lineHeight: "32px" }}>
                            <span style={{ fontWeight: "400" }}>{ReactHtmlParser(textofoto.replaceAll("**", "<b>").replaceAll("++", "</b>"))}</span>
                            <br />
                            <br /><span style={{ fontSize: "1.5rem" }}>{textofoto2}</span>
                            <br />
                        </p>
                    </div>
                    :
                    (eltipo.id == 40) ?
                        <div className="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-sm u-valign-middle-xl u-sheet-1">
                            <h2 className="u-align-center u-custom-font u-font-oswald u-text u-text-body-alt-color u-text-1">{titulofoto}<br />
                            </h2>
                            <p className="u-align-center u-large-text u-text u-text-body-alt-color u-text-variant u-text-2" data-animation-name="customAnimationIn" data-animation-duration="1000" data-animation-delay="0" style={{ lineHeight: "32px" }}>
                                <span style={{ fontWeight: "400" }}>{ReactHtmlParser(textofoto.replaceAll("**", "<b>").replaceAll("++", "</b>"))}</span>
                                <br />
                                <br /><span style={{ fontSize: "1.5rem" }}>{textofoto2}</span>
                                <br />
                            </p>
                        </div>
                        :
                        <>
                            <h2 className="u-align-center u-custom-font u-font-oswald u-text u-text-body-alt-color u-text-1">{titulofoto}<br />
                            </h2>
                            <p className="u-align-center u-large-text u-text u-text-body-alt-color u-text-variant u-text-2" data-animation-name="customAnimationIn" data-animation-duration="1000" data-animation-delay="0" style={{ lineHeight: "32px" }}>
                                <span style={{ fontWeight: "400" }}>{ReactHtmlParser(textofoto.replaceAll("**", "<b>").replaceAll("++", "</b>"))}</span>
                                <br />
                                <br /><span style={{ fontSize: "1.5rem" }}>{textofoto2}</span>
                                <br />
                            </p>
                        </>
                }
            </section >
        </>
    );
}


export default CabeceraTipoBarco;
